import { useMemo } from 'react';
import { AbiItem } from 'web3-utils';
import { useWeb3React } from '@web3-react/core';
import { constants, providers } from 'ethers';
import { getContract } from 'utils/address';
import Erc20 from 'config/abi/Erc20.json';



export const useContract = (abi: AbiItem, address: string, withSignerIfPossible = true) => {
  const { account, connector } = useWeb3React();

  return useMemo(() => {
    if (!address || !abi || !connector.provider) return null;
    const provider = new providers.Web3Provider(connector.provider!);
    if (address === constants.AddressZero) {
      return null;
    }

    try {
      return getContract(address, abi, provider, withSignerIfPossible && account ? account : undefined);
    } catch (error) {
      console.error('Failed to get contract', error);
      return null;
    }
  }, [address, abi, connector, withSignerIfPossible, account]);
};

// nft token contract
export const useToken = (address: string) => useContract( Erc20 as unknown as AbiItem, address);

export default useContract;
